/**
 * 안전한 문자열 처리 (null, undefined 일 경우 빈 문자열 반환)
 * @param value - 변환할 값
 * @returns 빈 문자열 또는 원본 문자열
 */
const toSafeString = (value: string | number | null | undefined): string => String(value ?? '').trim();

export default toSafeString;
